import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
import * as S from "./styled";

//Components
import LayoutModal from "../../../LayoutModal";
import Search from "../../../Search";
//hooks
import apiRequest from "../../../../hooks/apiRequest";
import useLoading from '../../../../hooks/useLoading';
//Interface
import { ICreate } from "Interfaces/ICreate";
import { IOrder } from "Interfaces/IOrder";
import { Inputs } from "Interfaces/IServiceOrder";
//utils
import { CurrencyFormat } from "utils/CurrencyFormat";
import FormatarData from "utils/FormatData";

export default function CreateOS({
  isOpenModal,
  setModalClose,
  refreshFrames,
  setToastData,
  setToastOpen
}: ICreate) {
  const {
    register,
    reset,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();
  const {
    isLoading: isLoadingSubmit,
    startLoading: startLoadingSubmit,
    stopLoading: stopLoadingSubmit
  } = useLoading();
  const [dataSale, setDataSale] = useState<IOrder | null>(null);

  const listHeadLensPonte = [
    "PONTE",
    "HOR. MAIOR",
    "VERT. MAIOR",
    "DIAG. MAIOR",
  ];

  const listHeadTable = [
    "Tipo",
    "Produto",
    "Qtd.",
    "Preço",
    "Desconto",
    "Subtotal",
  ];

  const fieldsOD = [
    { name: "spherical_right", label: "ESFÉRICO" },
    { name: "cylindrical_right", label: "CILÍNDRICO" },
    { name: "axis_right", label: "EIXO" },
    { name: "dnp_right", label: "DNP" },
    { name: "addition_right", label: "ADIÇÃO" },
    { name: "height_right", label: "ALTURA" },
  ] as const;

  const fieldsOE = [
    { name: "spherical_left", label: "ESFÉRICO" },
    { name: "cylindrical_left", label: "CILÍNDRICO" },
    { name: "axis_left", label: "EIXO" },
    { name: "dnp_left", label: "DNP" },
    { name: "addition_left", label: "ADIÇÃO" },
    { name: "height_left", label: "ALTURA" },
  ] as const;

  const fieldsBridge = [
    { name: "bridge", label: "PONTE" },
    { name: "larger_horizontal", label: "HORIZONTAL MAIOR" },
    { name: "larger_vertical", label: "VERTICAL MAIOR" },
    { name: "larger_diagonal", label: "DIAGONAL MAIOR" },
  ] as const;

  const fieldsDnpAlt = [
    { name: "dnp_v_right", label: "DNP V - OD" },
    { name: "dnp_v_left", label: "DNP V - OE" },
    { name: "alt_right", label: "ALT V - OD" },
    { name: "alt_left", label: "ALT V - OE" },
  ] as const;

  const fieldsPonte = [
    "bridge",
    "larger_horizontal",
    "larger_vertical",
    "larger_diagonal"
  ] as const;

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(
        `service-order`
      );
      const serviceOrders = response.data.data;
      // Pegando o maior valor de number_os
      const maxNumber = serviceOrders.length > 0 ? Math.max(...serviceOrders.map((order: any) => Number(order.number_os || 0))) : 0;

      // // Setando o próximo número automaticamente
      setValue("number_os", (maxNumber + 1).toString());
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModal) {
      fetchData();
    }
  }, [isOpenModal]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoadingSubmit();
    try {
      const payload = {
        ...data,
        sale_id: dataSale ? dataSale?.id : null,
      }
      const response = await apiRequest('service-order', 'POST', payload);
      if (response.status === 201) {
        setToastData({
          status: response.status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        onClose();
      }
    } catch (error: any) {
      console.log('error: ', error);
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoadingSubmit();
    }
  };

  const onClose = () => {
    setDataSale(null);
    setModalClose();
    reset();
  };

  const handleSaleSelect = (product: IOrder) => {
    console.log('produto: ', product);
    if (product) {
      setDataSale(product);
    }
  }

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoadingSubmit}
        title="Registrar Ordem de Serviço"
        subTitle="Cadastre uma nova os em sua base de dados."
        setModalClose={onClose}
        submiteModal={handleSubmit(onSubmit)}

        nameIconMinimize={'Registrar OS'}
      >
        <S.Container>
          {dataSale &&
            <S.ContentInfor>
              <S.Subtitle>Data da Venda: {FormatarData(dataSale.date_sale, 'default-data')}</S.Subtitle>
              <S.Subtitle>Vendedor: {dataSale.seller?.first_name || '-'}</S.Subtitle>
              <S.Subtitle>Laboratório: {
                dataSale.lenses.length > 0 ?
                  dataSale.lenses[0].laboratory?.laboratory || '-' :
                  'Não informado'
              }
              </S.Subtitle>
              <S.Subtitle>Pazo de entrega: {
                dataSale.lenses.length > 0 ?
                  `${dataSale.lenses[0].delivery || 'Não informado'} dia` :
                  'Não informado'
              }
              </S.Subtitle>
            </S.ContentInfor>
          }

          <Search
            label="Código de Venda"
            placeholder="Informe o código da venda"
            url="sale?number_ata="
            idSelect={handleSaleSelect}
          />

          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Ordem de Serviço
                <span>*</span>
              </S.Label>
              <S.Input
                isStyle={true}
                placeholder="Informe a ordem de serviço"
                type="string"
                {...register("number_os", { required: true })}
                as='input'
              />
              {errors.number_os && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>

            <S.FormInput>
              <S.Label>
                Data de Entrega
                <span>*</span>
              </S.Label>
              <S.Input
                isStyle={true}
                as='input'
                type="date"
                {...register("delivery", { required: true })} />
              {errors.delivery && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>
          </S.SeparateDiv>

          <S.FormInput>
            <S.Label>Observação</S.Label>
            <S.TextArea
              placeholder="Campo Opcional -  dicione observações relevantes sobre a OS"
              rows={2}
              {...register("observation")}
            />
          </S.FormInput>

          <S.Section>
            <S.HeaderSection>
              <S.Text className="title">
                Informações do Grau e Montagem
              </S.Text>
            </S.HeaderSection>

            <S.BodySection>
              <S.Text className="title">
                Olho Direito - OD
              </S.Text>

              <S.ContentGrid>
                {
                  fieldsOD.map((fieldName, index) => (
                    <S.FormInput className="form-center" key={index}>
                      <S.Label>
                        {fieldName.label || '-'}
                        <span>*</span>
                      </S.Label>
                      <S.Input
                        isStyle={false}
                        as='input'
                        placeholder="0"
                        type="text"
                        {...register(fieldName.name)}
                      />
                    </S.FormInput>
                  ))
                }
              </S.ContentGrid>
            </S.BodySection>

            <S.BodySection>
              <S.Text className="title">
                Olho Esquerdo - OE
              </S.Text>

              <S.ContentGrid>
                {
                  fieldsOE.map((fieldName, index) => (
                    <S.FormInput className="form-center" key={index}>
                      <S.Label>
                        {fieldName.label || '-'}
                        <span>*</span>
                      </S.Label>
                      <S.Input
                        isStyle={false}
                        as='input'
                        placeholder="0"
                        type="text"
                        {...register(fieldName.name)}
                      />
                    </S.FormInput>
                  ))
                }
              </S.ContentGrid>
            </S.BodySection>
          </S.Section>

          <S.Section>
            <S.HeaderSection>
              <S.Text className="title">
                Medidas Vision Office
              </S.Text>
            </S.HeaderSection>

            <S.BodySection>
              <S.Text className="title">
                Medidas da Ponte
              </S.Text>

              <S.ContentGrid>
                {
                  fieldsBridge.map((fieldName, index) => (
                    <S.FormInput className="form-center" key={index}>
                      <S.Label>
                        {fieldName.label || '-'}
                        <span>*</span>
                      </S.Label>
                      <S.Input
                        isStyle={false}
                        as='input'
                        placeholder="0"
                        type="text"
                        {...register(fieldName.name)}
                      />
                    </S.FormInput>
                  ))
                }
              </S.ContentGrid>
            </S.BodySection>

            <S.BodySection>
              <S.Text className="title">
                DNP V e ALT V por Olho
              </S.Text>

              <S.ContentGrid>
                {
                  fieldsDnpAlt.map((fieldName, index) => (
                    <S.FormInput className="form-center" key={index}>
                      <S.Label>
                        {fieldName.label || '-'}
                        <span>*</span>
                      </S.Label>
                      <S.Input
                        isStyle={false}
                        as='input'
                        placeholder="0"
                        type="text"
                        {...register(fieldName.name)}
                      />
                    </S.FormInput>
                  ))
                }
              </S.ContentGrid>
            </S.BodySection>
          </S.Section>

          <S.Text>
            <span>Legenda: </span>OD: OLHO DIREITO -
            OE: OLHO ESQUERDO -
            DNP: DISTÂNCIA NASO-PUPILAR |
            ALT: ALTURA |
            ADI: ADIÇÃO |
            DNP V: DISTÂNCIA NASO-PUPILAR VISION |
            ALT V: ALTURA VISION
          </S.Text>

          {/* table */}
          {dataSale &&
            <>
              <S.ContainerTable>
                <S.TableWrapper>

                  <S.Table>
                    <S.Thead>
                      <S.Tr>
                        {listHeadTable.map((header) => {
                          return <th>{header}</th>;
                        })}
                      </S.Tr>
                    </S.Thead>

                    <S.Tbody>
                      {
                        dataSale.frames.length > 0 &&
                        dataSale.frames.map((val, index) =>
                          <S.Tr>
                            <S.Td key={index}>
                              Armação
                            </S.Td>
                            <S.Td key={index}>
                              {val.code}
                            </S.Td>
                            <S.Td key={index}>
                              {val.pivot.quantity}
                            </S.Td>
                            <S.Td key={index}>
                              {CurrencyFormat(parseFloat(val.pivot.price || '0'))}
                            </S.Td>
                            <S.Td key={index}>
                              {CurrencyFormat(parseFloat(val.pivot?.discount_value || '0'))}
                            </S.Td>
                            <S.Td key={index}>
                              {CurrencyFormat(parseFloat(val.pivot.total || '0'))}
                            </S.Td>
                          </S.Tr>
                        )
                      }
                      {
                        dataSale.lenses.length > 0 &&
                        dataSale.lenses.map((val, index) =>
                          <S.Tr>
                            <S.Td key={index}>
                              Lente
                            </S.Td>
                            <S.Td key={index}>
                              {val.name_lens || '-'}
                            </S.Td>
                            <S.Td key={index}>
                              {val.pivot.quantity}
                            </S.Td>
                            <S.Td key={index}>
                              {CurrencyFormat(parseFloat(val.pivot.price || '0'))}
                            </S.Td>
                            <S.Td key={index}>
                              {CurrencyFormat(parseFloat(val.pivot?.discount_value || '0'))}
                            </S.Td>
                            <S.Td key={index}>
                              {CurrencyFormat(parseFloat(val.pivot.total || '0'))}
                            </S.Td>
                          </S.Tr>
                        )
                      }
                      {
                        dataSale.accessories.length > 0 &&
                        dataSale.accessories.map((val, index) =>
                          <S.Tr>
                            <S.Td key={index}>
                              Acessório
                            </S.Td>
                            <S.Td key={index}>
                              {val.barcode || '-'}
                            </S.Td>
                            <S.Td key={index}>
                              {val.pivot.quantity}
                            </S.Td>
                            <S.Td key={index}>
                              {CurrencyFormat(parseFloat(val.pivot.price || '0'))}
                            </S.Td>
                            <S.Td key={index}>
                              {CurrencyFormat(parseFloat(val.pivot?.discount_value || '0'))}
                            </S.Td>
                            <S.Td key={index}>
                              {CurrencyFormat(parseFloat(val.pivot.total || '0'))}
                            </S.Td>
                          </S.Tr>
                        )
                      }
                      {
                        dataSale.services.length > 0 &&
                        dataSale.services.map((val, index) =>
                          <S.Tr>
                            <S.Td key={index}>
                              Serviço
                            </S.Td>
                            <S.Td key={index}>
                              {val.name || '-'}
                            </S.Td>
                            <S.Td key={index}>
                              {val.pivot.quantity}
                            </S.Td>
                            <S.Td key={index}>
                              {CurrencyFormat(parseFloat(val.pivot.price || '0'))}
                            </S.Td>
                            <S.Td key={index}>
                              {CurrencyFormat(parseFloat(val.pivot?.discount_value || '0'))}
                            </S.Td>
                            <S.Td key={index}>
                              {CurrencyFormat(parseFloat(val.pivot.total || '0'))}
                            </S.Td>
                          </S.Tr>
                        )
                      }
                    </S.Tbody>
                  </S.Table>
                </S.TableWrapper>
              </S.ContainerTable>

              <S.ContentInfor>
                <S.Infor>
                  <S.Subtitle>Cliente</S.Subtitle>
                  <S.InforDescription>{dataSale.customer?.full_name || '-'}</S.InforDescription>
                </S.Infor>

                <S.Infor>
                  <S.Subtitle>Convênio</S.Subtitle>
                  <S.InforDescription>{dataSale.customer?.agreements?.agreement || 'Não informado'}</S.InforDescription>
                </S.Infor>

                <S.Infor>
                  <S.Subtitle>RG/CPF</S.Subtitle>
                  <S.InforDescription>{dataSale.customer?.rg || '-'}/{dataSale.customer?.cpf || '-'}</S.InforDescription>
                </S.Infor>
              </S.ContentInfor>

              <S.ContentInfor>
                <S.Subtitle>Total da Compra</S.Subtitle>
                <S.InforTitle>{CurrencyFormat(parseFloat(dataSale.total_amount || '0'))}</S.InforTitle>
              </S.ContentInfor>
            </>
          }
        </S.Container>
      </LayoutModal>
    );
  }
  return null;
}
